import React, { useEffect, Suspense, lazy, useState } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
const SignIn = lazy(() => import('../SignIn/index'));
const Signup = lazy(() => import('../Signup/Signup'));
const Product = lazy(() => import('../Productpage/Product'));
const Pricing = lazy(() => import('../Productpage/PricingPage/PricingPage'));
const UserSignup = lazy(() => import('../SubUserSignup/Signup'));
const Header = lazy(() => import('../Header/Header'));
const ContactUs = lazy(() => import('../ContactUs/ContactUs'));
const Navbar = lazy(() => import('../NavSettings/Navbar'));
const Success = lazy(() => import('../Payment/Success'));
const Failure = lazy(() => import('../Payment/Failure'));
const CancelSubscription = lazy(() => import('../Payment/CancelSubscription'));
const Error = lazy(() => import('../UI/Error/Error'));
const ForgotPassword = lazy(() => import('../UI/ForgotPassword/ForgotPassword'));
const CreateNew = lazy(() => import('../UI/ForgotPassword/CreateNew'));
import Loader from '../UI/Loader/Loader';
import Footer from '../Footer/Footer';
import AnnouncementWidget from '../UI/AnnouncementWidget/AnnouncementWidget';
import Faq from '../UI/FAQ/Faq';
import { Logout } from '../../Action/action';
import LogoutUser from '../UI/Logout';
import Payment from '../Productpage/Payment';
import StripeForms from '../UI/Stripe/StripeForms';

const AppRoute = () => {
  const isAuthenticated = document.cookie.indexOf('access_token');
  const profile = useSelector((state) => state.menuReducer.profile);
  const isAuth = useSelector((state) => state.AuthReducer.isAuthorised);
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const redirect = urlParams.get('redirect');
  const amount = urlParams.get('amount');
  const source = urlParams.get('source');

  axios.interceptors.response.use(
    (response) =>
      new Promise((resolve, reject) => {
        if (window._kc) {
          if (!window._kc.authenticated && isAuthenticated != -1) {
            dispatch(Logout());
          }
        }
        resolve(response);
      }),
    (error) => {
      if (!error.response) {
        return new Promise((resolve, reject) => {
          reject(error);
        });
      } else {
        return new Promise((resolve, reject) => {
          reject(error);
        });
      }
    },
  );

  useEffect(() => {
    if (window._kc) {
      if (!window._kc.authenticated && isAuthenticated != -1) {
        dispatch(Logout());
      }
    }
  }, [isAuth]);

  useEffect(() => {
    if (redirect === 'console') {
      if (amount && profile && source) {
        Payment('PAYG', profile?.email, 'DESK', null, amount, null, setLoader, source);
      }
    }
  }, [profile]);

  return (
    <>
      <Suspense fallback={<Loader />}>
        <Router>
          {
            <div>
              <Header />
              <div>
                {isAuth || isAuthenticated !== -1 ? (
                  <Switch>
                    <Route
                      exact
                      path="/"
                      component={redirect === 'console' ? Loader : Pricing}
                    />
                    <Route path="/product" component={Pricing} />
                    <Route path="/contact" component={ContactUs} />
                    <Route path="/transaction/success" component={Success} />
                    <Route path="/payment" component={StripeForms} />
                    <Route path="/transaction/failed" component={Failure} />
                    <Route path="/cancelled" component={CancelSubscription} />
                    <Route
                      path="/settings/:page?"
                      render={(props) => <Navbar {...props} />}
                    />
                    <Route path="/error" component={Error} />
                    <Redirect from="/*" to="/" />
                  </Switch>
                ) : (
                  <Switch>
                    <Route exact path="/" component={SignIn} />
                    <Route path="/signup" component={SignIn} />
                    <Route path="/userSignup" component={UserSignup} />
                    <Route path="/forgot_password" component={ForgotPassword} />
                    <Route path="/confirm_password" component={CreateNew} />
                    <Route path="/error" component={Error} />
                    <Route path="/logout" component={LogoutUser} />
                    <Redirect from="/*" to="/signup" />
                  </Switch>
                )}
                <Footer />
              </div>
            </div>
          }
        </Router>
      </Suspense>
    </>
  );
};
export default AppRoute;
